import React from "react";
import { useIsSharedDealSelect } from "store";

// Reverse returns component only if a deal belongs to another account
// Don't return child if the deal is shared
export const SharedDealGuard: React.FC<{ children: React.ReactNode; reverse?: boolean }> = ({ children, reverse }) => {
  const isSharedDeal = useIsSharedDealSelect();
  let isLocked = isSharedDeal;

  if (reverse) {
    isLocked = !isLocked;
  }

  if (isLocked) return null;

  return children;
};
